import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { BaseComponent } from '../base/base.component';

@Component({
  selector: 'app-query-layout',
  imports: [RouterOutlet],
  template: `
    <div class="tw-flex tw-max-w-[1300px]">
      <div class="tw-grow tw-px-4 sm:tw-px-8 tw-pt-4 tw-max-w-[1300px]">
        <router-outlet></router-outlet>
      </div>
    </div>
  `,
  styles: ``,
})
export class QueryLayoutComponent extends BaseComponent {}
